import React from 'react';
import {
  insertNodes,
  ELEMENT_PARAGRAPH,
} from '@udecode/plate';
import { useEditorRef, focusEditor, useEventPlateId } from '@udecode/plate-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import { ToolbarButton } from './ToolbarButton';
import { ELEMENT_PAGE_BREAK } from '../../plugins/page-break/createPageBreakPlugin';

export const PageBreakButton = ({ id, ...props }) => {
  const editor = useEditorRef(useEventPlateId(id));

  return (
    <ToolbarButton
      name="Insert page break"
      className={clsx('button--unstyled')}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        insertNodes(
          editor,
          [
            { type: ELEMENT_PAGE_BREAK, children: [{ text: '' }] },
            { type: ELEMENT_PARAGRAPH, children: [{ text: '' }] },
          ],
        );
        setTimeout(() => {
          focusEditor(editor);
        }, 0);
      }}
      onMouseDown={(e) => e.preventDefault()}
      {...props}
    >
      <FontAwesomeIcon icon={['fa', 'page-break']} />
    </ToolbarButton>
  );
};
